/**
 * Public runtime config rendered by FrontendConfigHelper as <meta name="..."> tags in the layout.
 *
 * Use this instead of import.meta.env.VITE_* for anything production needs: .env* files are
 * kept out of the production Docker build, so VITE_* values are undefined there.
 */
export type FrontendConfigKey = 'sentry-dsn' | 'carto-api-key' | 'guest-games-played' | 'map-tiles-host' | 'map-guide-tiles' | 'map-world-tiles' | 'map-pinpoint-tiles';

export function frontendConfig(key: FrontendConfigKey): string | undefined {
  return document.querySelector<HTMLMetaElement>(`meta[name="${key}"]`)?.content || undefined;
}
